import { PropsWithChildren } from 'react';

import {
  DataPopper,
  DataPopperRow,
  Typography,
  Box,
} from '@cast/design-system';

import { Money } from 'components/money';
import { DataTooltip } from '@cast/components-data-tooltip';
import { getNetworkCostPrecision } from 'features/cost-report/utils/networkCosts';

type Props = {
  egress: number;
  ingress: number;
  disable?: boolean;
};

export const CostDetailsTooltip = ({
  egress,
  ingress,
  disable,
  children,
}: PropsWithChildren<Props>) => {
  const total = egress + ingress;

  const egressPrecision = getNetworkCostPrecision(egress);
  const ingressPrecision = getNetworkCostPrecision(ingress);

  return (
    <DataTooltip
      title={
        <DataPopper size="small" sx={{ width: 210 }}>
          <DataPopperRow
            indicator={{
              color: 'indigo.200',
              variant: 'filled',
              size: 'small',
            }}
            left={<Typography variant="P10R">Egress</Typography>}
            right={
              <Typography variant="P10R">
                <Money
                  amount={egress}
                  precision={egressPrecision}
                  fixed={egressPrecision}
                />
              </Typography>
            }
          />

          <DataPopperRow
            indicator={{
              color: 'grey.700',
              variant: 'filled',
              size: 'small',
            }}
            left={<Typography variant="P10R">Ingress</Typography>}
            right={
              <Typography variant="P10R">
                <Money
                  amount={ingress}
                  precision={ingressPrecision}
                  fixed={ingressPrecision}
                />
              </Typography>
            }
          />
        </DataPopper>
      }
      placement="top"
      disableHoverListener={!total || disable}
    >
      <Box
        data-testid="network-cost-details-cell"
        flexGrow={1}
        maxWidth={160}
        minHeight={8}
      >
        {children}
      </Box>
    </DataTooltip>
  );
};
